import { i18n } from '@/plugins/i18n';
import { h } from 'vue';
import {
  NegarBasketArrowUpIcon,
  NegarDepositLightIcon,
  NegarWithdrawLightIcon,
  NegarBasketArrowDownIcon,
  NegarCreditCardIcon,
  NegarAnsarBankIcon,
  NegarAyandehBankIcon,
  NegarDeyBankIcon,
  NegarGardeshgariBankIcon,
  NegarGhavaminBankIcon,
  NegarIranzaminBankIcon,
  NegarKarafarinBankIcon,
  NegarKeshavarziBankIcon,
  NegarKosarBankIcon,
  NegarMarkaziBankIcon,
  NegarMaskanBankIcon,
  NegarMellatBankIcon,
  NegarMelliBankIcon,
  NegarMoaseseMelalBankIcon,
  NegarParsianBankIcon,
  NegarPasargadBankIcon,
  NegarPostBankIcon,
  NegarRefahBankIcon,
  NegarResalatBankIcon,
  NegarSaderatBankIcon,
  NegarSamanBankIcon,
  NegarSanatoMadanBankIcon,
  NegarSarmayeBankIcon,
  NegarSepahBankIcon,
  NegarShahrBankIcon,
  NegarSinaBankIcon,
  NegarTejaratBankIcon,
  NegarToseSaderatBankIcon,
  NegarToseTaavonBankIcon,
  NegarMehrIranBankIcon,
  NegarAsanPardakhtIcon,
} from '@negar/icons';

import ApLogo from '@/assets/images/ap_logo.svg';
import SamanLogo from '@/assets/images/saman_logo.svg';
import BehPardakhtLogo from '@/assets/images/beh_pardakht_logo.svg';

const { t } = i18n.global;

const DEPOSIT_RANGE = {
  minimum: 10_000,
  maximum: 1_000_000_000,
};

const BANKS = {
  ansar: {
    title: t('deposit.banks.ansar'),
    icon: h(NegarAnsarBankIcon),
  },
  ayandeh: {
    title: t('deposit.banks.ayandeh'),
    icon: h(NegarAyandehBankIcon),
  },
  dey: {
    title: t('deposit.banks.dey'),
    icon: h(NegarDeyBankIcon),
  },
  gardeshgari: {
    title: t('deposit.banks.gardeshgari'),
    icon: h(NegarGardeshgariBankIcon),
  },
  ghavamin: {
    title: t('deposit.banks.ghavamin'),
    icon: h(NegarGhavaminBankIcon),
  },
  iran_zamin: {
    title: t('deposit.banks.iranzamin'),
    icon: h(NegarIranzaminBankIcon),
  },
  karafarin: {
    title: t('deposit.banks.karafarin'),
    icon: h(NegarKarafarinBankIcon),
  },
  keshavarzi: {
    title: t('deposit.banks.keshavarzi'),
    icon: h(NegarKeshavarziBankIcon),
  },
  kosar: {
    title: t('deposit.banks.kosar'),
    icon: h(NegarKosarBankIcon),
  },
  markazi: {
    title: t('deposit.banks.markazi'),
    icon: h(NegarMarkaziBankIcon),
  },
  maskan: {
    title: t('deposit.banks.maskan'),
    icon: h(NegarMaskanBankIcon),
  },
  melat: {
    title: t('deposit.banks.mellat'),
    icon: h(NegarMellatBankIcon),
  },
  meli: {
    title: t('deposit.banks.melli'),
    icon: h(NegarMelliBankIcon),
  },
  melal: {
    title: t('deposit.banks.moaseseMelal'),
    icon: h(NegarMoaseseMelalBankIcon),
  },
  parsian: {
    title: t('deposit.banks.parsian'),
    icon: h(NegarParsianBankIcon),
  },
  pasargad: {
    title: t('deposit.banks.pasargad'),
    icon: h(NegarPasargadBankIcon),
  },
  post: {
    title: t('deposit.banks.post'),
    icon: h(NegarPostBankIcon),
  },
  refah: {
    title: t('deposit.banks.refah'),
    icon: h(NegarRefahBankIcon),
  },
  resalat: {
    title: t('deposit.banks.resalat'),
    icon: h(NegarResalatBankIcon),
  },
  saderat: {
    title: t('deposit.banks.saderat'),
    icon: h(NegarSaderatBankIcon),
  },
  saman: {
    title: t('deposit.banks.saman'),
    icon: h(NegarSamanBankIcon),
  },
  industry_mine: {
    title: t('deposit.banks.sanatoMadan'),
    icon: h(NegarSanatoMadanBankIcon),
  },
  sarmaye: {
    title: t('deposit.banks.sarmaye'),
    icon: h(NegarSarmayeBankIcon),
  },
  sepah: {
    title: t('deposit.banks.sepah'),
    icon: h(NegarSepahBankIcon),
  },
  shahr: {
    title: t('deposit.banks.shahr'),
    icon: h(NegarShahrBankIcon),
  },
  sina: {
    title: t('deposit.banks.sina'),
    icon: h(NegarSinaBankIcon),
  },
  tejarat: {
    title: t('deposit.banks.tejarat'),
    icon: h(NegarTejaratBankIcon),
  },
  toseeh_saderat: {
    title: t('deposit.banks.toseSaderat'),
    icon: h(NegarToseSaderatBankIcon),
  },
  toseeh_tavoon: {
    title: t('deposit.banks.toseTaavon'),
    icon: h(NegarToseTaavonBankIcon),
  },
  mehr_iran: {
    title: t('deposit.banks.mehrIran'),
    icon: h(NegarMehrIranBankIcon),
  },
  ap: {
    title: t('deposit.banks.ap'),
    icon: h(NegarAsanPardakhtIcon),
  },
  hekmat_iraninan: {
    title: t('deposit.banks.hekmatIranian'),
    icon: h(NegarCreditCardIcon),
  },
  iran_venezuela: {
    title: t('deposit.banks.iranVenezuela'),
    icon: h(NegarCreditCardIcon),
  },
  mehr_eghtesad: {
    title: t('deposit.banks.mehrEghtesad'),
    icon: h(NegarCreditCardIcon),
  },
  tosseh: {
    title: t('deposit.banks.tosseh'),
    icon: h(NegarCreditCardIcon),
  },
  khavaremiane: {
    title: t('deposit.banks.khavaremiane'),
    icon: h(NegarCreditCardIcon),
  },
  noor: {
    title: t('deposit.banks.noor'),
    icon: h(NegarCreditCardIcon),
  },
  blue_bank: {
    title: t('deposit.banks.blueBank'),
    icon: h(NegarCreditCardIcon),
  },
  eghtesad_novin: {
    title: t('deposit.banks.eghtesadNovin'),
    icon: h(NegarCreditCardIcon),
  },
};

const PAYMENT_GATEWAYS = {
  direct: {
    value: 0,
    title: t('deposit.directDebit'),
  },
  saman: {
    value: 1,
    title: t('deposit.saman_gateway'),
  },
  ap: {
    value: 3,
    title: t('deposit.ap_gateway'),
  },
  behPardakht: {
    value: 4,
    title: t('deposit.behPardakhtGateway'),
  },
} as const;

const PAYMENT_GATEWAYS_RESULT = {
  1: {
    name: 'سامان',
    title: t('payment.banks.saman_gateway'),
    image: { src: SamanLogo, alt: 'saman_logo' },
  },
  4: {
    name: 'ملت',
    title: t('payment.banks.behPardakhtGateway'),
    image: {
      src: BehPardakhtLogo,
      alt: 'beh_pardakht_logo',
    },
  },
  3: {
    name: 'آپ',
    title: t('payment.banks.ap_gateway'),
    image: { src: ApLogo, alt: 'ap_logo' },
  },
} as const;

const SUCCESSFUL_PAYMENT_STATES = ['OK', '1', '0'];

const MINIMUM_PAY_FAST_WITHDRAWAL_VALUE = 10000;

const OPERATION_TYPE = {
  1: {
    type: 'buy',
    icon: h(NegarBasketArrowUpIcon),
    label: t('common.buy'),
  },

  2: {
    type: 'sell',
    icon: h(NegarBasketArrowDownIcon),
    label: t('common.sell'),
  },
  5: {
    type: 'withdraw',
    icon: h(NegarWithdrawLightIcon),
    label: t('misc.removal'),
  },
  6: {
    type: 'deposit',
    icon: h(NegarDepositLightIcon),
    label: t('misc.settle'),
  },
};

const MAX_BANK_ACCOUNT_NUMBER = 24;

export {
  DEPOSIT_RANGE,
  PAYMENT_GATEWAYS,
  SUCCESSFUL_PAYMENT_STATES,
  MINIMUM_PAY_FAST_WITHDRAWAL_VALUE,
  OPERATION_TYPE,
  PAYMENT_GATEWAYS_RESULT,
  MAX_BANK_ACCOUNT_NUMBER,
  BANKS,
};
